/**
 * Created by sagardesai on 22/06/18.
 */

export const FOLLOWING_LIST_REQUEST = "FOLLOWING_LIST_REQUEST";
export const FOLLOWING_LIST_RECEIVE = "FOLLOWING_LIST_RECEIVE";
export const FOLLOWING_LIST_FAILURE = "FOLLOWING_LIST_FAILURE";
export const RESET_FOLLOWING_LIST = "RESET_FOLLOWING_LIST";

export const FOLLOW_UNFOLLOW_BROADCASTER_REQUEST = "FOLLOW_UNFOLLOW_BROADCASTER_REQUEST";
export const FOLLOW_UNFOLLOW_BROADCASTER_RECEIVE = "FOLLOW_UNFOLLOW_BROADCASTER_RECEIVE";
export const FOLLOW_UNFOLLOW_BROADCASTER_FAILURE = "FOLLOW_UNFOLLOW_BROADCASTER_FAILURE";
export const RESET_FOLLOW_UNFOLLOW_BROADCASTER = "RESET_FOLLOW_UNFOLLOW_BROADCASTER";

export const SET_SEARCH_FOLLOWING_STATE = "SET_SEARCH_FOLLOWING_STATE";

export const FAVORITE_BROADCASTER_REQUEST = "FAVORITE_BROADCASTER_REQUEST"
export const FAVORITE_BROADCASTER_RECEIVE = "FAVORITE_BROADCASTER_RECEIVE"
export const FAVORITE_BROADCASTER_FAILURE = "FAVORITE_BROADCASTER_FAILURE"